module.exports = __webpack_public_path__ + "static/media/Retângulo 714@2x.ec9de65c.png";